import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const KpiAreaChart = ({ data, title, color = '#007bff' }) => {
  // Modify the data to enable fill for area chart and match preview styling
  const areaData = {
    ...data,
    datasets: data.datasets?.map(dataset => ({
      ...dataset,
      fill: true,
      backgroundColor: dataset.backgroundColor || (dataset.seriesColor ? dataset.seriesColor + '20' : (dataset.borderColor || color) + '20'), // Add transparency
      borderColor: dataset.borderColor || dataset.seriesColor || color,
      borderWidth: dataset.borderWidth || 2,
    })) || []
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: !!title,
        text: title,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div style={{ height: '300px', width: '100%' }}>
      <Line data={areaData} options={options} />
    </div>
  );
};

export default KpiAreaChart;
